export default "/assets/images/app-update-img-01.8aff8487ea81acb1.webp";